<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="small">
          <div class="backborder3">
              <el-col :span="24">
	              <el-col :span="7">
	                  <el-form-item label="客户头像">
                          <input type="file" id="coverthumb" @change="uploadfiles($event)" style="display:none"/>
	                  	  <a class="cz-customer-infos-thumb" @click="addcoverthumb">
                              <img :src="create.thumb!='' ? create.thumb : require('../../assets/customer/customer_default.png')" />
                          </a>
	                  </el-form-item>
	              </el-col>
              </el-col>
          </div>
      	  <div class="backborder3" style="margin-top:10px">
              <el-col :span="24">
	              <el-col :span="7" v-if="isshowshop!=1">
	                  <el-form-item label="客户名称" prop="name">
	                  	  <el-input v-model="create.name" @blur="simpleSlice"></el-input>
	                  </el-form-item>
	              </el-col>
	              <el-col :span="7">
	                  <el-form-item label="客户简称" prop="simple">
	                  	  <el-input v-model="create.simple"></el-input>
	                  </el-form-item>
	              </el-col>
	              <el-col :span="5">
	                  <el-form-item label="拼音码" prop="pym">
	                  	  <el-input v-model="create.pym"></el-input>
	                  </el-form-item>
	              </el-col>
	              <el-col :span="7">
		              <el-form-item label="客户编码" prop="number">
		              	  <el-input v-model="create.number"></el-input>
		              </el-form-item>
	              </el-col>
	              <el-col :span="7">
	                  <el-form-item label="联系电话">
	                  	  <el-input v-model="create.phone"></el-input>
	                  </el-form-item>
	              </el-col>
	              <el-col :span="5" v-if="isshowshop==1">
	                  <el-form-item label="所属店铺" prop="shopname">
	                  	  <el-input v-model="create.shopname" @focus="chooseShop"></el-input>
	                  </el-form-item>
	              </el-col>
              </el-col>
          </div>
          <div class="backborder3" style="margin-top:10px">
              <el-col :span="24">
              	  <el-col :span="7">
	                  <el-form-item label="客户分类">
		                  <el-select v-model="create.groupid" placeholder="请选择客户分类" prop="groupid">
		                      <el-option label="不分类" value="0"></el-option>
		                      <el-option v-for="(item,index) in classlists" :label="item.groupname" :value="item.id" :key="index"></el-option>
		                  </el-select>
	                  </el-form-item>
                  </el-col>
                  <el-col :span="7">
	                  <el-form-item label="客户等级">
		                  <el-select v-model="create.levelid" placeholder="请选择客户等级" prop="levelid" clearable>
		                      <el-option v-for="(item,index) in levellists" :label="item.name" :value="item.id" :key="index"></el-option>
		                  </el-select>
	                  </el-form-item>
                  </el-col>
                  <el-col :span="7" v-if="islineclerk==false">
		              <el-form-item label="销售人员" prop="clerkid">
		              	  <el-select v-model="create.clerkid" placeholder="请选择销售员" clearable>
	                      	  <el-option v-for="(item,index) in clerklists" :label="item.name" :value="item.id" :key="index"></el-option>
	                  	  </el-select>
		              </el-form-item>
              	  </el-col>
                  <el-col :span="7" v-if="islineclerk==true">
		              <el-form-item label="线下销售" prop="clerkid">
		              	  <el-select v-model="create.clerkid" placeholder="请选择销售员" clearable>
	                      	  <el-option v-for="(item,index) in clerklists" :label="item.name" :value="item.id" :key="index"></el-option>
	                  	  </el-select>
		              </el-form-item>
              	  </el-col>
                  <el-col :span="7" v-if="islineclerk==true">
		              <el-form-item label="线上销售" prop="clerkid">
		              	  <el-select v-model="create.lineclerkid" placeholder="请选择销售员" clearable>
	                      	  <el-option v-for="(item,index) in clerklists" :label="item.name" :value="item.id" :key="index"></el-option>
	                  	  </el-select>
		              </el-form-item>
              	  </el-col>
          	  </el-col>
          </div>          
          <div class="backborder3" style="margin-top:10px">
          	  <el-col :span="24">
	              <el-col :span="7">
		              <el-form-item label="所在城市" prop="cityid">
		              	  <el-cascader :options="citys" v-model="create.cityids" clearable></el-cascader>
		              </el-form-item>
	              </el-col>
	              <el-col :span="7">
		              <el-form-item label="所在区域" prop="district_name">
		              	  <el-select v-model="create.district_name" placeholder="请选择客户分类" prop="groupid" clearable>
		                      <el-option v-for="(item,index) in selectdistrict" :label="item.district_name" :value="item.district_name" :key="index"></el-option>
		                  </el-select>
		              </el-form-item>
	              </el-col>
	              <el-col :span="7">
	                  <el-form-item label="所在位置">
	                  	  <el-input v-model="create.position" @focus="getmapinfos()" readonly></el-input>
	                  </el-form-item>
	              </el-col>
	              <el-col :span="21">
	                  <el-form-item label="详细地址">
	                  	  <el-input v-model="create.address"></el-input>
	                  </el-form-item>
	              </el-col>    
              </el-col>
          </div>
          <div class="backborder3" style="margin-top:10px">
          	  <el-col :span="7">
                  <el-form-item label="初应收款" prop="receivable">
                  	  <el-input v-model="create.receivable"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="7">
	              <el-form-item label="预存金额" prop="balance">
	              	  <el-input v-model="create.balance" :disabled="true"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="7">
                  <el-form-item label="应收上限" prop="maxreceivable">
                  	  <el-input v-model="create.maxreceivable"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="7">
                  <el-form-item label="结算期限" prop="period">
                  	  <el-input v-model="create.period"><template slot="append">天</template></el-input>
                  </el-form-item>
              </el-col>
          </div>
          <div class="backborder3" style="margin-top:10px;">
          	  <el-col :span="8">
	              <el-form-item label="备注">
	                  <el-input type="textarea" v-model="create.note" :autosize="{ minRows: 4, maxRows: 8}"></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="24" align="right" style="margin-bottom:30px">
              	  <el-form-item>
            		  <el-button size="small" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
	              </el-form-item>
              </el-col>
          </div>          
      </el-form>
      
      <!-------------- 展示地图信息 ------------------->
	  <el-dialog title="地图信息展示" :visible.sync="showmapDialog" top="3vh" width="55%">	    
	      <template> 
			  <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler" @click="getlocalposition" :scroll-wheel-zoom="true" v-loading="mapLoading">
    			  <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="false" :autoLocation="true" :locationIcon="{size: {width: 18, height: 18}}" @locationSuccess="getLoctionSuccess" @locationError="getLocationError"></bm-geolocation>
    			  <!-- 自定义定位图标覆盖物 -->
    			  <bm-marker :position="markerPoint" :dragging="true" :auto-viewport='true' animation="BMAP_ANIMATION_BOUNCE"  v-if="initLocation"></bm-marker>
    			  <!-- 左边放大缩小工具 -->
    			  <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    			  <bm-control :offset="{width: '100%', height: '10px'}">
			          <bm-auto-complete v-model="maplocation" :sugStyle="{zIndex: 999999}">
			              <input type="text" placeholder="请输入搜索关键字" class="serachinput">
			          </bm-auto-complete>
			      </bm-control>
			      <bm-local-search :keyword="maplocation" :auto-viewport="true" style="width:0px;height:0px;overflow: hidden;" @searchcomplete="markersset"></bm-local-search>   				
  			  </baidu-map>
  			  <el-button size="small" type="primary" @click="gobackcenter">返回中心位置</el-button>	    
		  </template>			
		  <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="showmapDialog = false">取 消</el-button>
              <el-button size="small" type="primary" @click="savelocation">保 存</el-button>
          </div>
	  </el-dialog>
          

      
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      isshowshop:2,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        thumb:'',
        name:'',
        number:'',
        shopid:'',
        simple:'',
        pym:'',
        address:'',
        phone:'',
        receivable:'',
        advance:'',
        maxreceivable:'',
        balance:0.00,
        groupid:'',
        levelid:'',
        period:'',
        note:'',
        cityids:[],
        district_id:0,
        district_name:'不选择区域',
        position:'',
        clerkid:'',
        lineclerkid:'',
      },
      classlists:[],
      citys:[],
      clerklists:[],
      createLoading: false,
      
      /** 百度地图相关 **/
      center: {
      	  lng: 116.046671,
      	  lat: 40.269514,
      },
      markerPoint: {
      	  lng: '',
      	  lat: '',
      },
      zoom:'',
      classListLoading:false,
      classlists:[],
      istype:[],
      typelists:[],
      chooseShopLoading:false,
      shoplists:[],
      choose_total_rows:0,
      choose:{
        act:'shoplists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      selectdistrictDialog:false,
      selectdistrictlistsLoading:false,
      selectdisstrictquery: {
          act:'districtlists',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 1000000,
          p: 1
      },
      selectdistrict:[],
      select_district_total_rows:0,
      createLoading:false,
      initLocation:false,
      showmapDialog:false,
      mapLoading:false,
      maplocation:'',
      
      rules: {
        name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
        shopid: [
            { min: 1, max: 10, message: '长度在 1 到 10 个字符'},
            { pattern:/^[0-9]+$/, message: '编号只能为数字'}
        ],
        simple: [
        	{ required: true, message: '请填写客户简称', trigger: 'blur' },
        ],
        pym: [
        	{ required: true, message: '请填写客户拼音码', trigger: 'blur' },
        ],
        groupid: [
        	{ required: true, message: '请选择客户分类', trigger: 'blur' },
        ],
        cityids: [
        	{ required: true, message: '请选择所属城市', trigger: 'blur' },
        ],
        receivable: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '应收款只能为数值'}
        ],
        advance: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '预收款只能为数值'}
        ],
        maxreceivable: [
            { pattern:/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/, message: '应收款只能为数值'}
        ]
      },
      levelquery: {
      	  act:'getLevel',
          token:this.$cookies.get('token'),
          key:'',
          rollpage: 1000,
          p: 1
      },
      levellists:[],
      islineclerk:false,
      
    }
  },
  mounted(){
      this.getactionauth();
      this.getClassList(); //获取客户分类
      this.getclerklists(); //获取负责销售员
      this.getCitys(); //获取城市分类信息
      this.getselectdistrictlists(); //获取客户区域列表
      this.getLevel(); //获取客户等级信息
      this.getislineclick(); //获取是否有权限添加线上销售员
  },
  methods:{  
  	//重置表单
    reset() {
        this.$refs.create.resetFields();
    },
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 获取是否有权限添加线上销售员信息 **/
    getislineclick() {
        var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'islineclerk',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var result = JSON.parse(Base64.decode(res.data.Data));
                this.islineclerk=result.islineclerk==0 ? false : true;	          
	        }
        }).catch((res) => {

        });
    },
    
    //获取客户等级信息
    getLevel() {
        var resource = this.$resource(this.url);
        resource.query(this.levelquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.levellists = JSON.parse(Base64.decode(res.data.Data));	          
	        }
        }).catch((res) => {

        });
    },
    
    //分类列表
    getClassList(){
        this.classListLoading = true;
        var resource = this.$resource(this.url);
        resource.query({ act:'getclass',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.classListLoading = false;
	        }else{
	            this.classlists = JSON.parse(Base64.decode(res.data.Data));	          
	            var _this=this;
	            this.classlists.forEach(function(e,index){  
	          	    e.istype==0 ? _this.istype.splice(index,1,false) : _this.istype.splice(index,1,true);
	          	    _this.typelists.splice(index,1,e.discount);
	            }); 	          
	            this.classListLoading = false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.classListLoading=false;
        });
    },
    
    //简称
    simpleSlice(){
        this.create.simple=this.create.name.slice(0,6);
        var resource = this.$resource(this.GLOBAL.domain+"Pinyin/index",);
        resource.query({ str:this.create.simple,token:this.$cookies.get('token')}).then((res) => {
        	this.create.pym=res.data.Message;
        });
    },
    
    //选择店铺编号
    chooseShop(){
        this.chooseShopDialog=true;
        this.getShopList();
    },
    
    getShopList(){
        this.chooseShopLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.choose).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.chooseShopLoading = false;
	        }else{
	            this.shoplists = JSON.parse(Base64.decode(res.data.Data));
	            this.choose_total_rows=parseInt(res.data.count);
	            this.chooseShopLoading = false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.chooseShopLoading=false;
        });
    },
    pageChooseSizeChange(val) {
        this.choose.rollpage = val;
        this.getShopList();
    },
    pageChooseCurrentChange(val) {
        this.choose.p = val;
        this.getShopList();
    },
    
    //获取客户区域信息列表
    selectdistricts() {
    	this.selectdistrictDialog=true;
		this.getselectdistrictlists();
    },
    
    //获取客户区域列表
    getselectdistrictlists() {
    	var resource = this.$resource(this.url);
    	resource.query(this.selectdisstrictquery).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	        }else{
	          var data = JSON.parse(Base64.decode(res.data.Data));
	          var _this=this;
	          this.selectdistrict=[];
	          this.selectdistrict.push({id:0,district_name:'不选择区域'});
	          data.forEach(function(e,index) {_this.selectdistrict.push(e)});
	        }
        }).catch((res) => {

        });
    },
    
    /** 获取店铺当前的位置 **/
    getmapinfos() {  
    	this.zoom=5;
    	this.initLocation = true;
    	this.showmapDialog=true;    	
    },
    
    //获取职员信息列表
    getclerklists() {
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'getallclerks',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	        }else{
	          this.clerklists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取城市列表信息 **/
    getCitys() {
        var resource = this.$resource(this.GLOBAL.domain+"Address/getcitylists");
        resource.query({token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.citys = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          
        });
    },
    
    
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login');
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createLoading=false;
                    this.reset();
                    this.setcreatenull(); //置空客户管理信息
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createLoading=false;
              });
          }else {
              return false;
          }
      });
    },
    
    /** 置空客户信息 **/
    setcreatenull() {
        this.create.name='';
        this.create.thumb='';
        this.create.shopid='';
        this.create.simple='';
        this.create.pym='';
        this.create.address='';
        this.create.phone='';
        this.create.receivable='';
        this.create.advance='';
        this.create.maxreceivable='';
        this.create.groupid='';
        this.create.period='';
        this.create.note='';
        this.create.cityids=[];
    },
    
    /** 获取当前位置经纬度 **/
    getlocalposition(e) {
    	this.zoom = e.target.getZoom();  	
    	this.markerPoint.lng=e.point.lng;    	
    	this.markerPoint.lat=e.point.lat;
    },
    
    /** 检索完成回调函数  **/
    markersset(e) {    
    	this.maplocation='';
    },
    
    /** 返回中心位置 **/
    gobackcenter() {
    	this.center.lng=116.046671; //地图中心展示的经度
        this.center.lat=40.269514; //地图中心展示的纬度 	
    },
    
    /** 保存选取的经纬度 **/
    savelocation() {
    	this.showmapDialog=false;
    	if(this.markerPoint.lng=='') {this.$message.error("请选择您的位置");return false;}
    	this.create.position=this.markerPoint.lat+","+this.markerPoint.lng;
    },


    /** 点击修改头像 **/
    addcoverthumb() {
        document.getElementById('coverthumb').click();
    },

    /** 获取图片信息回传 **/
	uploadfiles(el) {
		var images=el.target.files;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    for (let i = 0; i < el.target.files.length; i++) {
	    	var formData = new FormData();
	    	formData.append('file', el.target.files[i]);
            formData.append('sys_type', 'cz');
            formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    	resource.save(formData).then((res) => {
		        var data=JSON.parse(Base64.decode(res.body.Data));
		        if(data.Result > 0) {
		            this.$message.error(data.msg);
		        }else {
					this.create.thumb=this.GLOBAL.staticUrl+data.imgsrc;	
		        }
		    }).catch((res) => {
		        	
		    });
	    }
		el.target.value = '';
	},
    
    
  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
.cz-customer-infos-thumb {box-shadow:2px 2px 10px #dddddd;cursor:pointer;float:left;width:55px;height:55px;padding:5px;border-radius:50%;border:1px solid rgba(221,221,221,.6);background:#F2F6FC;overflow:hidden;}
.cz-customer-infos-thumb img {float:left;width:100%;border-radius:50%;}
</style>


// WEBPACK FOOTER //
// src/components/base/Customeradd.vue